import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const AvailableDayTime = () => {
  const [snackbarMessage, setSnackbarMessage] = useState('');
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [showpostModel, setShowpostModel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [runningList, setRunningList] = useState([]);
    const [runningTimeList, setRunningTimeList] = useState([]); 
    const [selectedDays, setSelectedDays] = useState([]);
    const history = useHistory();
    const [authError, setAuthError] = useState('');
    const [formData, setFormData] = useState({
        from_time: '',
        to_time: ''
    });

    useEffect(() => {
      getAvailableDays();
      // getAvailableTime();
    }, []);

    const getAvailableDays = async () => {
      setLoading(true);
      const tokens = localStorage.getItem('token');
      try {
          const response = await axios.get(`${var_api}/api/shop-day-master/get`, {
              headers: { 'Authorization': tokens },
          });
          setRunningList(response.data);
      } catch (error) {
          console.log('Error fetching data:', error);
          if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
      } finally {
          setLoading(false);
      }
  };

  // const getAvailableTime = async () => {
  //     setLoading(true);
  //     const tokens = localStorage.getItem('token');
  //     try {
  //         const response = await axios.get(`${var_api}/api/shop-time-master/get`, {
  //             headers: { 'Authorization': tokens },
  //         });
  //         setRunningTimeList(response.data);
  //     } catch (error) {
  //         console.log('Error fetching data:', error);
  //         if (error.response && error.response.status === 401) {
  //             history.push('/signin');
  //         }
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const availableDaysputStatus = async (item) => {
    setLoading(true);
    const tokens = localStorage.getItem('token');
console.log("item",item)
const newStatus = item.active_status === 1 ? 0 : 1;
    try {
        // Toggle active_status
        // const newStatus = item.active_status === 1 ? 0 : 1;

        // Construct the payload
        const putData = {
            day: item.day,
            active_status: newStatus,
            remark: item.remark || ''
        };

        // PUT request to update day availability
        const response = await axios.put(`${var_api}/api/shop-day-master/put/${item.id}`, putData, {
            headers: { 'Authorization': tokens }
        });

        // Handle the response
        if (response.data.status === 'errors') {
            setAuthError(response.data.data);
            getAvailableDays();
            // getAvailableTime();
        } else {
            Swal.fire("Success", "Status updated successfully!", "success");
            getAvailableDays(); // Refresh the list
            // getAvailableTime();
        }
    } catch (error) {
        console.error("Error updating day availability:", error);
        Swal.fire("Error", "Failed to update availability.", "error");
    } finally {
        setLoading(false);
    }
};

    // const handleCheckboxChange = (id) => {
    //     const updatedDays = selectedDays.includes(id)
    //         ? selectedDays.filter(dayId => dayId !== id)
    //         : [...selectedDays, id];
    //     setSelectedDays(updatedDays);
    // };
    const handleCheckboxChange = (id) => {
      const selectedDay = runningList.find(day => day.id === id); // Find the selected day
  
      if (selectedDay) {
          if (selectedDays.includes(id)) {
              // Unselecting the checkbox
              const updatedDays = selectedDays.filter(dayId => dayId !== id);
              setSelectedDays(updatedDays);
  
              // Clear the time fields if no checkboxes are selected
              if (updatedDays.length === 0) {
                  setFormData({
                      ...formData,
                      from_time: '',
                      to_time: ''
                  });
              }
          } else {
              // Selecting the checkbox
              const updatedDays = [...selectedDays, id];
              setSelectedDays(updatedDays);
  
              // Populate the time fields with the selected day's times
              setFormData({
                  ...formData,
                  from_time: selectedDay.from_time || '', // Default to empty if no time
                  to_time: selectedDay.to_time || ''     // Default to empty if no time
              });
          }
      }
  };
  

    const handleSubmit = async (e) => {
      e.preventDefault();
    
      const tokens = localStorage.getItem('token');
    
      if (selectedDays.length === 0) {
        Swal.fire("Error", "Please select a day before submitting.", "warning");
        return;
      }
    
      if (!formData.from_time || !formData.to_time) {
        Swal.fire("Error", "Please select both From Time and To Time.", "warning");
        return;
      }
    
      if (formData.from_time >= formData.to_time) {
        setShowModel(true); // Show the popup if time range validation fails
        return;
      }
    
      const postDays = selectedDays.filter(dayId => {
        const selectedDay = runningList.find(day => day.id === dayId);
        return selectedDay && (!selectedDay.from_time || !selectedDay.to_time);
      });
    
      const putDays = selectedDays.filter(dayId => {
        const selectedDay = runningList.find(day => day.id === dayId);
        return selectedDay && selectedDay.from_time && selectedDay.to_time;
      });
    
      setLoading(true);
    
      try {
        if (postDays.length > 0) {
          await availableDaysPost(postDays);
        }
        if (putDays.length > 0) {
          await availableDaysPut(putDays);
        }
    
        setSnackbarMessage('Status updated successfully!');
        setShowSnackbar(true);
        getAvailableDays();
      } catch (error) {
        console.error("Submission error:", error);
        Swal.fire("Error", "Failed to save time.", "error");
      } finally {
        setLoading(false);
      }
    };
    

      const availableDaysPost = async (postDays, putDays) => {
        const tokens = localStorage.getItem('token');
        const timeSlots = postDays.map(dayId => {
          const selectedDay = runningList.find(day => day.id === dayId);
          return {
            id: selectedDay?.time_id,
            day_id: dayId,
            from_time: formData.from_time,
            to_time: formData.to_time,
            remark: formData.remark || '',
          };
        });
      
        try {
          const response = await axios.post(`${var_api}/api/shop-time-master/post`, { timeSlots }, {
            headers: { 'Authorization': tokens },
          });
      
          if (response.data.status === 'errors') {
            setAuthError(response.data.data);
          } else {
            resetForm();
            setShowpostModel(true);
          }
        } catch (error) {
          console.error("Error in availableDaysPost:", error);
        }
      };
      
      const availableDaysPut = async (postDays) => {
        const tokens = localStorage.getItem('token');
        const timeSlots = postDays.map(dayId => {
          const selectedDay = runningList.find(day => day.id === dayId);
          return {
            id: selectedDay?.time_id,
            day_id: dayId,
            from_time: formData.from_time,
            to_time: formData.to_time,
            remark: formData.remark || '',
          };
        });
      
        try {
          const response = await axios.put(`${var_api}/api/shop-time-master/put`, { timeSlots }, {
            headers: { 'Authorization': tokens },
          });
      
          if (response.data.status === 'errors') {
            setAuthError(response.data.data);
          } else {
            resetForm();
            setShowpostModel(true);
          }
        } catch (error) {
          console.error("Error in availableDaysPut:", error);
        }
      };
  

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleGoToHome = () => {
      history.push('/sb-home');
    }

    const resetForm = () => {
      setFormData({
          from_time: '',
          to_time: ''
      });
      setSelectedDays([]); 
  };

    return (
      <>
      {loading && <Loader />}  
      <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       Available Day & Time
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome}  style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
        <div className='whole' style={{ backgroundColor: "white" }}>
            {/* {showSnackbar && <div className='snackbar success'>{snackbarMessage}</div>} */}
            <Form onSubmit={handleSubmit} style={{ width: '50%', margin: 'auto' }}>
            <label>From Time</label>
                <div className='form-floating mb-3'>
                    <input
                        type='time'
                        className='form-control'
                        name='from_time'
                        value={formData.from_time}
                        onChange={handleInputChange}
                        placeholder='From Time'
                        style={{ borderRadius: '15px' }}
                        required
                    />
                </div>
                <label>To Time</label>
                <div className='form-floating mb-3'>
                    <input
                        type='time'
                        className='form-control'
                        name='to_time'
                        value={formData.to_time}
                        onChange={handleInputChange}
                        placeholder='To Time'
                        style={{ borderRadius: '15px' }}
                        required
                    />
                </div>
                <Button
    variant="primary"
    type="submit"
    className="mt-3"
    style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
  >
    {selectedDays.some(dayId => {
      const selectedDay = runningList.find(day => day.id === dayId);
      return selectedDay?.from_time && selectedDay?.to_time;
    })
      ? 'Update'
      : 'Submit'}
  </Button>{" "}
        <Button variant="danger" className="mt-3" onClick={resetForm} >
          Reset
        </Button>
            </Form>
            
            <table className='table table-hover table-striped align-middle mt-4' style={{ width: '80%', margin: 'auto' }}>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Day</th>
                        <th>Status</th>
                        <th>Select</th>
                        <th>From - To</th>
                    </tr>
                </thead>
                <tbody>
                    {runningList.map((item, index) => (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.day}</td>
                            {/* <td>
                                <label className="switch">
                                    <input type="checkbox" checked={item.active_status === 1} onChange={() => availableDaysput(item)} />
                                    <span className="slider round"></span>
                                </label>
                            </td> */}
                            <td>
                            <Form.Check
                                type="switch"
                                // id={`custom-switch-${item.id}`}
                                label=""
                                checked={item.active_status === 1}
                                onChange={(e) => availableDaysputStatus(item)}
                            />
                        </td>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={selectedDays.includes(item.id)}
                                    onChange={() => handleCheckboxChange(item.id)}
                                />
                            </td>
                            <td>{item.from_time} - {item.to_time}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        </>
    );
};


export default AvailableDayTime;